































































































































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import * as _ from 'lodash';
// import { DEFAULT_DATE_FORMAT } from '@/common/config'
import * as routeNames from '../router-names';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import { exportOrderPay, queryOrderPayList } from '../../../api/order-management';

import Utils from '@/utils/common';
import { issuedStatusMap } from '../../../types/order-management/dictionaries';
import moment from 'moment';

import PlateInput from '../../../components/plate-input/index.vue';
import { Getter } from 'vuex-class';
import { isShiDaill } from '@/utils/env';
import RangePickerBox from '@/components/range-picker-box/index.vue';

const defaultParams = {
  parkIds: [],
  plateHead: '', // 车牌号
  plateTail: '', // 车牌号
  createStartTime: '',
  createEndTime: '',
  paidStartTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
  paidEndTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59',
  issuedStatus: '',
  payMethods: [],
  payChannels: [],
  pkPayId: '',
  sentryId: '',
  plateMobile: '',
  paidAmountOrderBy: '',
  totalAmountOrderBy: ''
};

@Component({
  name: 'TradeRecordList',
  components: {
    ParkingLotSearch,
    PlateInput,
    RangePickerBox
  }
})
export default class TradeRecordList extends Mixins(TableMixin) {
  isshidaill: boolean = isShiDaill;

  // 下发状态
  private issuedStatusList = Utils.toLabelVal(issuedStatusMap);
  // 支付方式
  @Getter('dictionaries/orderPayMethod')
  orderPayMethod?: any;
  get payMethodsList() {
    return Utils.toLabelVal(this.orderPayMethod);
  }
  // private payMethodsList = Utils.toLabelVal(payMethodsMap)
  // 支付渠道

  @Getter('dictionaries/orderPayChannel')
  orderPayChannel?: any;
  get payChannelsList() {
    return Utils.toLabelVal(this.orderPayChannel);
  }

  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  plateInputModel = false;
  // 表格Loading
  private tableLoading: boolean = false;
  tableData: any = [];
  private filterParam = {
    ...defaultParams
  };

  clear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList,
      ...defaultParams
    };
    this.fetchTableData();
  }

  private created() {
    //this.fetchTableData()
  }
  activated() {
    this.$nextTick(() => {
      if (this.$route.query.parkId) {
        const query: any = this.$route.query;
        this.filterParam.paidEndTime = query.endTime || '';
        this.filterParam.paidStartTime = query.startTime || '';
        this.filterParam.parkIds = query.parkId ? [query.parkId] : [];
        this.filterParam.sentryId = query.sentryId || '';
        this.filterParam.payMethods = [];
        this.filterParam.payMethods.push('00');
      }
      this.fetchTableData();
    });
  }
  get defaultTime() {
    if (this.filterParam.paidStartTime && this.filterParam.paidEndTime) {
      return [
        moment(this.filterParam.paidStartTime, 'YYYY-MM-DD HH:mm:ss'),
        moment(this.filterParam.paidEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.paidStartTime) {
      return [moment(this.filterParam.paidStartTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }

  set defaultTime(val: any) {}

  get createTime() {
    if (this.filterParam.createStartTime && this.filterParam.createEndTime) {
      return [
        moment(this.filterParam.createStartTime, 'YYYY-MM-DD HH:mm:ss'),
        moment(this.filterParam.createEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.createStartTime) {
      return [moment(this.filterParam.createStartTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }

  set createTime(val: any) {}

  /**
   * 搜索
   */
  private search() {
    try {
      this.filterParam.sentryId = '';
      this.fetchTableData();
    } catch (e) {
      console.log(e);
    }
  }

  public async fetchTableData() {
    if (this.createTime.length === 0 && this.defaultTime.length === 0) {
      this.$message.warn('订单创建时间和支付时间不能同时为空');
      return;
    }
    try {
      // 时间跨度判断拦截 （单车场可跨365天，多车场最多可跨30天）

      const exitEnterTimeoffsetDays = this.filterParam.parkIds.length === 1 ? 365 : 30;
      if (
        moment(this.filterParam.paidEndTime).diff(moment(this.filterParam.paidStartTime), 'days') >
        exitEnterTimeoffsetDays
      ) {
        this.$message.warn(`查询条件：交易时间，跨度不可超过${exitEnterTimeoffsetDays}天`);
        return;
      }

      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkIds = [],
        plateHead = '', // 车牌号
        plateTail = '', // 车牌号
        createStartTime = '',
        createEndTime = '',
        paidStartTime = '',
        paidEndTime = '',
        issuedStatus = [],
        payMethods = [],
        payChannels = [],
        pkPayId = '',
        sentryId = '',
        plateMobile = '',
        paidAmountOrderBy = '',
        totalAmountOrderBy = ''
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }

      const { status, msg, code, data } = await queryOrderPayList({
        parkIds: '' + parkIds,
        plateHead,
        plateTail,
        createStartTime,
        createEndTime,
        paidStartTime,
        paidEndTime,
        issuedStatus: '' + issuedStatus,
        payMethods: '' + payMethods,
        payChannels: '' + payChannels,
        currPage: this.current,
        pageSize: this.pageSize,
        pkPayId,
        sentryId,
        plateMobile,
        paidAmountOrderBy,
        totalAmountOrderBy
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        if (datas.length !== 0) {
          datas.push({
            ...total,
            cancelAmount: total.specialAmount,
            isTotal: true
          });
          this.tableData = Object.freeze(datas);
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log(error);
      console.log('queryOrderPayList  接口调用错误');
    } finally {
      this.tableLoading = false;
    }
  }

  exportLoading = false;
  private async download() {
    if (this.exportLoading) return;
    // if (this.total > 50000) {
    //   this.exportLoading = false
    //   return this.$message.error('导出最大只能支持五万条')
    // }
    this.exportLoading = true;
    try {
      const {
        parkIds = [],
        plateHead = '', // 车牌号
        plateTail = '', // 车牌号
        paidStartTime = '',
        paidEndTime = '',
        issuedStatus = [],
        payMethods = [],
        payChannels = [],
        pkPayId = '',
        plateMobile = '',
        paidAmountOrderBy = '',
        totalAmountOrderBy = ''
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行导出');
      }
      await exportOrderPay(
        {
          parkIds: '' + parkIds,
          plateHead,
          plateTail,
          paidStartTime,
          paidEndTime,
          issuedStatus: '' + issuedStatus,
          payMethods: '' + payMethods,
          payChannels: '' + payChannels,
          pkPayId,
          plateMobile,

          paidAmountOrderBy,
          totalAmountOrderBy
        },
        '交易记录'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportOrderPay', '导出失败');
    } finally {
      this.exportLoading = false;
    }
  }

  private rangePickerDefaultValue = [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')];

  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 订单创建时间改变
  onCreateTimeChange(date: [], dateString: any) {
    const [createStartTime, createEndTime] = dateString;
    this.filterParam.createEndTime = createEndTime;
    this.filterParam.createStartTime = createStartTime;
  }

  // 支付时间改变
  onTradingTimeChange(date: [], dateString: any) {
    const [paidStartTime, paidEndTime] = dateString;
    this.filterParam.paidEndTime = paidEndTime;
    this.filterParam.paidStartTime = paidStartTime;
  }

  // 查看图片
  reviewImages(imgSrc: string) {
    console.log(imgSrc);
  }

  toDetail(obj: any) {
    this.$router.push({
      name: routeNames.TRADE_RECORD_DETAIL,
      query: {
        pkPayId: obj.pkPayId,
        parkId: obj.parkId
      }
    });
  }
  toParkRecordList(obj: any) {
    const isDefaultTime: any = true;
    this.$router.push({
      name: routeNames.PARKING_RECORD_LIST,
      params: {
        plate: obj.plate,
        isDefaultTime
      }
    });
  }
  get tableColums() {
    if (this.isshidaill)
      return [
        {
          title: '序号',
          width: 100,
          customRender: (text: any, record: any, index: number) => {
            if (record.isTotal === true) {
              return '';
            }
            return `${(this.current - 1) * this.pageSize + index + 1}`;
          }
        },
        {
          title: '车场名称',
          dataIndex: 'parkName',
          width: 170,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '车牌号',
          dataIndex: 'plate',
          width: 140,
          scopedSlots: { customRender: 'plate' }
        },
        {
          title: '支付渠道',
          dataIndex: 'payChannelName',
          width: 140
        },
        {
          title: '支付方式',
          dataIndex: 'payMethodName',
          width: 140
        },
        {
          title: '下发状态',
          dataIndex: 'issuedStatusName',
          width: 140
        },
        {
          title: '应收金额',
          dataIndex: 'totalAmount',
          width: 140,
          sortable: true,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '实收金额',
          dataIndex: 'paidAmount',
          width: 140,
          sortable: true,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '优惠金额',
          dataIndex: 'discountAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '应收未收',
          dataIndex: 'unpaidAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '减免金额',
          dataIndex: 'cancelAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '开票状态',
          dataIndex: 'invoiceStatusName',
          width: 140
        },
        {
          title: '交易流水号',
          dataIndex: 'pkPayId',
          width: 230,
          scopedSlots: { customRender: 'pkPayId' }
          // scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '手机号',
          dataIndex: 'plateMobile',
          width: 140,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '支付时间',
          dataIndex: 'paidTime',
          width: 200
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 170,
          scopedSlots: { customRender: 'text-ellipse' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          width: 80
        }
      ];

    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 160,
        scopedSlots: { customRender: 'plate' }
      },
      {
        title: '支付渠道',
        dataIndex: 'payChannelName',
        width: 140
      },
      {
        title: '支付方式',
        dataIndex: 'payMethodName',
        width: 140
      },
      {
        title: '下发状态',
        dataIndex: 'issuedStatusName',
        width: 140
      },
      {
        title: '应收金额',
        dataIndex: 'totalAmount',
        width: 140,
        sortable: true,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '实收金额',
        dataIndex: 'paidAmount',
        width: 140,
        sortable: true,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '优惠金额',
        dataIndex: 'discountAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '应收未收',
        dataIndex: 'unpaidAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '减免金额',
        dataIndex: 'cancelAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '开票状态',
        dataIndex: 'invoiceStatusName',
        width: 140
      },
      {
        title: '交易流水号',
        dataIndex: 'pkPayId',
        width: 230,
        scopedSlots: { customRender: 'pkPayId' }
      },
      {
        title: '订单创建时间',
        dataIndex: 'createTime',
        width: 200
      },
      {
        title: '支付时间',
        dataIndex: 'paidTime',
        width: 200
      },
      {
        title: '备注',
        dataIndex: 'remark',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 80
      }
    ];
  }
  // 表头筛选
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
}
